/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Restart_ToastInputs */

const en_us2_plan_build_restart_toast = /** @type {(inputs: Plan_Build_Restart_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week 1 starts today.`)
};

const pt_br2_plan_build_restart_toast = /** @type {(inputs: Plan_Build_Restart_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana 1 começa hoje.`)
};

const es_419_plan_build_restart_toast = /** @type {(inputs: Plan_Build_Restart_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La semana 1 empieza hoy.`)
};

const pt_pt2_plan_build_restart_toast = /** @type {(inputs: Plan_Build_Restart_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A semana 1 começa hoje.`)
};

const fr_fr2_plan_build_restart_toast = /** @type {(inputs: Plan_Build_Restart_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La semaine 1 commence aujourd'hui.`)
};

const de_de2_plan_build_restart_toast = /** @type {(inputs: Plan_Build_Restart_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woche 1 beginnt heute.`)
};

const it_it2_plan_build_restart_toast = /** @type {(inputs: Plan_Build_Restart_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La settimana 1 inizia oggi.`)
};

/**
* | output |
* | --- |
* | "Week 1 starts today." |
*
* @param {Plan_Build_Restart_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_restart_toast = /** @type {((inputs?: Plan_Build_Restart_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Restart_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_restart_toast(inputs)
	if (locale === "es-419") return es_419_plan_build_restart_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_restart_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_restart_toast(inputs)
	if (locale === "de-DE") return de_de2_plan_build_restart_toast(inputs)
	if (locale === "it-IT") return it_it2_plan_build_restart_toast(inputs)
	return en_us2_plan_build_restart_toast(inputs)
});
export { plan_build_restart_toast as "plan-build.restart_toast" }